module.exports = __webpack_public_path__ + "static/media/default-avatar.0a6a3e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default-avatar.png
// module id = 345
// module chunks = 42